import { render, staticRenderFns } from "./PrioridadeDashSideBar.vue?vue&type=template&id=6aa66074&scoped=true"
import script from "./PrioridadeDashSideBar.vue?vue&type=script&lang=js"
export * from "./PrioridadeDashSideBar.vue?vue&type=script&lang=js"
import style0 from "./PrioridadeDashSideBar.vue?vue&type=style&index=0&id=6aa66074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa66074",
  null
  
)

export default component.exports